type ShowTooltip = (left: number, top: number, items: string[], rightAligned?: boolean) => void;

const TOOLTIP_HALF_MAX_WIDTH = 160;
const TOOLTIP_VERTICAL_OFFSET = 6;

export const showFilterBarButtonTooltip = (
  target: HTMLElement,
  tooltipText: string,
  showTooltip: ShowTooltip,
) => {
  const rect = target.getBoundingClientRect();
  const centerX = rect.left + rect.width / 2;
  const rightAligned = centerX + TOOLTIP_HALF_MAX_WIDTH > window.innerWidth;

  showTooltip(
    rightAligned ? rect.right : centerX,
    rect.bottom + TOOLTIP_VERTICAL_OFFSET,
    [tooltipText],
    rightAligned,
  );
};